// Lista y orden fijados por dirección (2026-08-31). Los de importe fijo lo
// rellenan solos al elegirlos; concepto e importe siguen siendo editables.
// «Devolución» (dirección, 2026-09-08): para apuntar a mano una devolución
// desde Cobros, aparte de las que vuelca solas «Facturas y devoluciones».
// El importe se escribe en positivo y se guarda en negativo, sin IVA.
export const COBRO_CONCEPT_PRESETS = [
  { value: 'Consulta ordinaria', amount: 50, amountLabel: '50 €' },
  { value: 'Consulta premium', amount: 200, amountLabel: '200 €' },
  { value: 'Hialuronidasa', amount: 250, amountLabel: '250 €' },
  { value: 'Reserva', amount: 450, amountLabel: '450 €' },
  { value: 'Chalazión', amountLabel: 'Importe manual' },
  { value: 'Cirugía oculoplastia', amountLabel: 'Importe manual' },
  { value: 'Cirugía rinoplastia', amountLabel: 'Importe manual' },
  { value: 'Cirugía lifting', amountLabel: 'Importe manual' },
  { value: 'Cirugía de Retoque', amountLabel: 'Importe manual' },
  { value: 'Retoque', amountLabel: 'Importe manual' },
  { value: 'CO2', amountLabel: 'Importe manual' },
  { value: 'Devolución', amountLabel: 'Importe manual', devolucion: true },
];

export const DEVOLUCION_CONCEPT = 'Devolución';

export const COBRO_AMOUNT_PRESETS = [50, 200, 250, 300, 450];

const normalize = (value) => (value || '')
  .trim()
  .toLocaleLowerCase('es-ES')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '');

/** ¿Es una devolución? «Devolución», «devolucion — reserva», «DEVOLUCIÓN cobro duplicado»… */
export function isDevolucionConcept(value) {
  return normalize(value).startsWith('devolucion');
}

/**
 * ¿Es el cobro de una RESERVA? La misma regla que el servidor
 * (services/funnel.es_cobro_de_reserva: el concepto contiene «reserv»). Una
 * devolución nunca lo es, aunque diga «devolución de la reserva». Es la
 * regla del embudo y del sello del presupuesto: con ella Cobros no ofrece el
 * campo «Presupuesto» (la reserva sella el suyo). Qué cobro paga la reserva
 * de qué cita lo dice cada tipo de cita (15/10/2026, `cobroPagaLaReserva`).
 */
export function isReservaConcept(value) {
  return !isDevolucionConcept(value) && String(value || '').toLowerCase().includes('reserv');
}

/**
 * ¿Es el pago de una CIRUGÍA (el resto de su presupuesto)? Los presets de
 * concepto no llevan categoría, así que va con la misma clase de regla que el
 * servidor usa para la reserva (una palabra en el concepto, sin tildes ni
 * mayúsculas): «cirug» o «retoque». Cubre los presets «Cirugía
 * oculoplastia / rinoplastia / lifting», «Cirugía de Retoque» y «Retoque», y
 * lo que se escriba a mano con esas palabras. La reserva y la devolución no
 * cuentan aunque las lleven. Con ella, Cobros, la ficha y el Datáfono dejan
 * elegido el presupuesto pendiente más reciente (12/10/2026).
 */
export function isCirugiaConcept(value) {
  if (isDevolucionConcept(value) || isReservaConcept(value)) return false;
  const n = normalize(value);
  return n.includes('cirug') || n.includes('retoque');
}

export function findCobroConceptPreset(value) {
  const normalized = normalize(value);
  return COBRO_CONCEPT_PRESETS.find((preset) => normalize(preset.value) === normalized) || null;
}

export function canonicalCobroConcept(value) {
  return findCobroConceptPreset(value)?.value || (value || '').trim();
}

export function amountOptionsForConcept(value) {
  const preset = findCobroConceptPreset(value);
  const preferred = preset?.amounts || (preset?.amount != null ? [preset.amount] : []);
  return [...new Set([...preferred, ...COBRO_AMOUNT_PRESETS])];
}

/**
 * Devuelve el importe que debe aplicarse al elegir un concepto exacto.
 * `null` indica que el concepto es libre; `''`, que el concepto existe pero
 * requiere que la persona elija o escriba el importe.
 */
export function suggestedAmountForConcept(value) {
  const preset = findCobroConceptPreset(value);
  if (!preset) return null;
  return preset.amount != null ? String(preset.amount) : '';
}
